import React, { useState, useEffect } from "react";
import NFCManager from "./components/NFCManager";
/* import AddSong from "./components/AddSong"; */
import SongList from "./components/SongList";
import SpotifyIntegration from "./components/SpotifyIntegration";
/* import Footer from "./components/Footer"; */
import AuthManager from "./components/AuthManager";
import { getAuth, signOut } from "firebase/auth";
import { Dropdown } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";

const App = () => {
  const [user, setUser] = useState(null); // Usuario autenticado
  const [showNavbar, setShowNavbar] = useState(true);
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleTagRead = (data) => {
    console.log("Datos leídos del NFC:", data);
  };

  const handleTagWrite = () => {
    console.log("Etiqueta NFC escrita.");
  };

  // Función para cerrar sesión
  const handleSignOut = async () => {
    const auth = getAuth();
    try {
      await signOut(auth); // Cerrar sesión en Firebase
      setUser(null); // Restablecer el estado del usuario
      console.log("Sesión cerrada exitosamente.");
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  // Manejo del scroll para mostrar/ocultar la barra superior
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      setShowNavbar(currentScrollPos < scrollPosition || currentScrollPos === 0);
      setScrollPosition(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [scrollPosition]);

  return (
    <div className="app-container">
      {!user ? (
        <AuthManager onUserAuthenticated={setUser} />
      ) : (
        <>
          {/* Barra superior con ícono y detalles del usuario */}
          <div
            className={`navbar-container ${
              showNavbar ? "visible" : "hidden"
            } d-flex justify-content-between align-items-center p-3 bg-light shadow-sm`}
          >
            <h1 className="text-center mt-2">Bienvenido, {user.name}</h1>
            <div className="user-container">
              <div className="user-icon">
                <i className="bi bi-person-circle fs-3"></i>
              </div>
              <div className="user-details">
                <span className="name">{user.name}</span>
                <span className="email">{user.email}</span>
              </div>
              <Dropdown id="dropdown-user">
                <Dropdown.Toggle variant="light" className="border-0">
                  <i className="bi bi-three-dots"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={handleSignOut}>
                    <i className="bi bi-box-arrow-right"></i> Cerrar Sesión
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
             
          </div>

          {/* Sección para buscar canciones en Spotify */}
          <SpotifyIntegration />

          {/* Formulario para agregar canciones manualmente */}
          {/* <AddSong /> */}

          {/* Lista de canciones gestionadas */}
          <SongList onAssignTag={handleTagWrite} />

          {/* Gestión de etiquetas NFC */}
          <NFCManager onTagRead={handleTagRead} onTagWrite={handleTagWrite} />
        </>
      )}

      {/* Footer */}
      {/* {<Footer /> } */}

    </div>
    
  );
};

export default App;